const newArea = {
  snackbar: "Your update is ready",
  name: "Plant Name",
  save: "Save",
  cancel: "Cancel",
  area: "Plant",
  formTitle: "New Plant",
  confirm: "Are you sure you want to delete this item?",
  close: "Close",
  delete: "Delete",
  selectCompany: "Select a Company"
};
export default newArea;
